import { render, staticRenderFns } from "./GuideBlock.vue?vue&type=template&id=255b5132&scoped=true"
import script from "./GuideBlock.vue?vue&type=script&lang=js"
export * from "./GuideBlock.vue?vue&type=script&lang=js"
import style0 from "./GuideBlock.vue?vue&type=style&index=0&id=255b5132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b5132",
  null
  
)

export default component.exports